export enum FilterSubEventType {
  ADMIN_USER_LOGIN_SUCCESS = 'admin_user_login_success',
  ADMIN_USER_LOGIN_FAILURE = 'admin_user_login_failure',
  IDP_USER_CREATED = 'idp_user_created',
}
